import { Animation } from './types';

export const ANIMATIONS_CONFIG = [
  { id: 'fadeIn', label: 'Fade In', icon: '✨' },
  { id: 'fadeOut', label: 'Fade Out', icon: '🌫️' },
  { id: 'slideLeft', label: 'Slide Left', icon: '⬅️' },
  { id: 'slideRight', label: 'Slide Right', icon: '➡️' },
  { id: 'slideUp', label: 'Slide Up', icon: '⬆️' },
  { id: 'slideDown', label: 'Slide Down', icon: '⬇️' },
  { id: 'zoomIn', label: 'Zoom In', icon: '🔍' },
  { id: 'zoomOut', label: 'Zoom Out', icon: '🔎' }
] satisfies Animation[];

export const ANIMATION_DURATION = 4000;
